// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"80":"7978e5db","371":"44e03472","538":"8b62155d","910":"fe6a3834","983":"d8325fc8"}[chunkId] + ".chunk.js";
};